<template>
  <div class="tree-container">
    <div style="display: flex">
      <div ref="inputContainer" class="input-container">
        <span>{{ value.name }}</span>
        <i class="el-icon-close" @click="removeValue" />
      </div>
      <div class="expanded-icon" @click="show = !show">
        <i class="el-icon-caret-bottom" />
      </div>
    </div>
    <div v-if="show" style="background: white">
      <!-- <el-input v-model="searchInputText" placeholder="search..." /> -->
      <div class="tree-box">
        <TreeView :data="data" @valueChanged="onValueChanged" />
      </div>
    </div>
  </div>
</template>
<script>
import TreeView from './treeView.vue'
export default {
  name: 'SelectWithTreeView',
  components: {
    TreeView
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      searchInputText: null,
      value: '',
      show: false,
      defaultTreeData: [
        {
          title: 'Đồ ăn',
          id: '1',
          active: true,
          children: [
            {
              title: 'Món ăn nóng',
              id: '1.1',
              active: true,
              children: [
                {
                  title: 'Mì tôm',
                  id: '1.1.1',
                  active: true
                },
                {
                  title: 'Bánh mì',
                  id: '1.1.2',
                  active: true
                }
              ]
            },
            {
              title: 'Món ăn nguội',
              id: '1.2',
              active: true
            }
          ]
        },
        {
          title: 'Đồ uống',
          id: '2',
          active: true
        },
        {
          title: 'Đồ nhắm',
          id: '3',
          active: true
        }
      ],
      treeData: [
        {
          title: 'Đồ ăn',
          id: '1',
          active: true,
          children: [
            {
              title: 'Món ăn nóng',
              id: '1.1',
              active: true,
              children: [
                {
                  title: 'Mì tôm',
                  id: '1.1.1',
                  active: true
                },
                {
                  title: 'Bánh mì',
                  id: '1.1.2',
                  active: true
                }
              ]
            },
            {
              title: 'Món ăn nguội',
              id: '1.2',
              active: true
            }
          ]
        },
        {
          title: 'Đồ uống',
          id: '2',
          active: true
        },
        {
          title: 'Đồ nhắm',
          id: '3',
          active: true
        }
      ]
    }
  },
  // computed: {
  //   treeDataStore() {
  //     return this.$store.getters['treeSearchData']
  //   }
  // },
  watch: {
    // treeDataStore() {
    //   this.value = this.treeDataStore.value
    //   this.show = false
    // },
    value() {
      this.$emit('change', this.value)
    },
    searchInputText() {
      // console.log('Watch aaaaaaaaaaaaaa', this.searchInputText)
      // this.treeData.forEach(item => {
      //   if (item.title.includes(this.searchInputText)) {

      //   }
      // })
      // this.treeData = []
      this.treeData = this.filter(this.defaultTreeData, this.searchInputText)
    }
  },
  mounted() {
    this.$refs.inputContainer.addEventListener('click', () => {
      this.show = true
    })
  },
  methods: {
    filter(array, value) {
      function find(object) {
        return Object.values(object).some(
          v => v === value || (v && typeof v === 'object' && find(v))
        )
      }

      return array.filter(find)
    },

    removeValue() {
      this.value = null
      setTimeout(() => {
        this.show = false
      })
    },
    onValueChanged(data) {
      this.show = false
      this.value = data
      this.$emit('change', data)
    }
  }
}
</script>

<style lang="scss">
.tree-container {
  width: 200px;
  position: relative;
  .input-container {
    width: 100%;
    display: flex;
    cursor: text;
    justify-content: space-between;
    border: 1px solid grey;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    padding: 3px 5px;

    span {
      // background: red
    }

    i {
      cursor: pointer;
    }
  }
  .expanded-icon {
    cursor: pointer;
    background: orange;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    // margin-left: 3px;
  }
  .tree-box {
    // padding: 5px;
    // box-sizing: border-box;
    width: 100%;
    box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px,
      rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px,
      rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px;
    background: white;
    height: 200px;
    overflow: auto;
    overflow-x: auto;
    position: absolute;
    z-index: 1;
  }
}
</style>
